/**
 * 콘솔 탭 네비게이션 순수 로직(#27).
 *
 * 한 컬럼 끝없는 스크롤 대신 패널을 탭으로 그룹화한다. 여기엔 탭 식별자·기본 탭·
 * localStorage 키, 그리고 저장값 검증·키보드 네비 계산만 둔다(브라우저 I/O·렌더 없음).
 * DOM/스토리지 접근은 페이지 쪽에서 하고, 이 모듈은 vitest로 단위 검증한다.
 */

export const DEBUG_TAB_IDS = [
  'live',
  'score',
  'tuning',
  'diagnostics',
  'help',
] as const;

export type TabId = (typeof DEBUG_TAB_IDS)[number];

/** 라이브 탭(실시간 그래프)이 기본. */
export const DEFAULT_TAB: TabId = 'live';

/** 선택 탭 기억 키. */
export const TAB_STORAGE_KEY = 'muzly.debug.activeTab';

export const isTabId = (value: unknown): value is TabId =>
  typeof value === 'string' &&
  (DEBUG_TAB_IDS as readonly string[]).includes(value);

/** 저장값이 유효한 탭이면 그대로, 아니면(없음/구버전/오염) 기본 탭으로 폴백. */
export const resolveInitialTab = (stored: string | null | undefined): TabId =>
  isTabId(stored) ? stored : DEFAULT_TAB;

/**
 * 탭바 키보드 네비(← → Home End): 현재 인덱스에서 이동할 다음 인덱스.
 * 좌우는 끝에서 순환하고, 그 외 키는 현재 인덱스를 유지한다.
 */
export const nextTabIndex = (
  current: number,
  key: string,
  count: number,
): number => {
  if (count <= 0) {
    return current;
  }
  if (key === 'ArrowRight') {
    return (current + 1) % count;
  }
  if (key === 'ArrowLeft') {
    return (current - 1 + count) % count;
  }
  if (key === 'Home') {
    return 0;
  }
  if (key === 'End') {
    return count - 1;
  }
  return current;
};
